import Vue from 'vue'
const { DateTime } = require('luxon')
let limitsTimeInterval = null
export default {
  getModelingTree({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.serviceTree, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        r.body.tree = r.body.tree.map((v) =>
          v.sort((a, b) => {
            if (a.name > b.name) {
              return 1
            }
            if (a.name < b.name) {
              return -1
            }
            return 0
          })
        )
        commit('setModelingServiceData', r.body)
      })
  },
  getModelingHistory({ commit, getters }, params) {
    const existingHistory = getters.versionList.filter((v) => v.version === params.version)[0]
    if (!params.updateFirst && existingHistory.history.length === existingHistory.history.count) {
      return Promise.resolve()
    }
    return Vue.http
      .get(getters.endpoint.versionHistory, {
        params: {
          workspace: getters.workspace,
          event: 'button',
          offset: params.updateFirst ? 0 : existingHistory.history.length,
          limit: 100,
          version: params.version
        }
      })
      .then((r) => {
        const months = ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря']
        const versions = getters.versionList.concat([])
        const versionIndex = versions.findIndex((v) => v.version === params.version)

        versions[versionIndex].count = r.body.count

        const newHistory = r.body.results.map((v) => {
          const currentDate = DateTime.fromISO(v.timestamp)
          return {
            ...v,
            dateText: currentDate.toFormat('dd') + ' ' + months[currentDate.toFormat('M') - 1] + ' ' + currentDate.toFormat('yyyy'),
            createdTime: currentDate.toFormat('T')
          }
        })
        if (params.updateFirst) {
          if (versions[versionIndex].history.length > 0) {
            const firstElement = versions[versionIndex].history[0]
            const firstElementIndex = newHistory.findIndex((v) => v.id === firstElement.id)
            if (firstElementIndex === -1) {
              versions[versionIndex].history = newHistory
            } else {
              versions[versionIndex].history = newHistory.slice(0, firstElementIndex).concat(versions[versionIndex].history)
            }
          } else {
            versions[versionIndex].history = newHistory
          }
        }
        if (getters.versionList && getters.versionList.length > 0 && !params.updateFirst) {
          const existingHistoryIds = versions[versionIndex].history.map((v) => v.id)
          const uniqueResults = newHistory.filter((v) => existingHistoryIds.indexOf(v.id) === -1)
          versions[versionIndex].history = versions[versionIndex].history.concat(uniqueResults)
        }
        commit('setVersionList', versions)
      })
  },
  activateVersion({ commit, getters }, version) {
    return Vue.http
      .post(getters.endpoint.activateVersion(version), null, {
        params: {
          workspace: getters.workspace
        }
      })
      .then((r) => {
        commit('setVersion', r.body.version)
      })
  },
  clearAllModeling({ commit, dispatch }) {
    dispatch('clearVersionHistory')
    dispatch('clearModeling')
  },
  clearModeling({ commit, dispatch }) {
    commit('setModelingServiceData', null)
    commit('setSelectedService', null)
    commit('setSelectedServiceDetails', null)
  },

  setModelingSelectedService({ commit, dispatch }, service) {
    commit('setSelectedService', service)
  },

  getModelingSelectedServiceDetails({ commit, getters }, buttonId) {
    if (!buttonId) {
      commit('setSelectedServiceDetails', null)
      return Promise.resolve()
    }

    return Vue.http
      .get(getters.endpoint.serviceButtonParameters, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          button: buttonId
        }
      })
      .then((r) => {
        commit('setSelectedServiceDetails', r.body)
        return r.body
      })
  },
  getModelingInitWorkspaceDetails({ commit, getters }, saveInState = false) {
    return Vue.http.get(getters.endpoint.initWorkspaceParameters).then((r) => {
      if (saveInState) {
        commit('setSelectedServiceDetails', r.body)
      }
      return r.body
    })
  },
  modelingInitWorkspace({ commit, getters, dispatch }, params) {
    const multipart = new FormData()
    Object.keys(params.files).forEach((key) => {
      multipart.append(key, params.files[key])
    })
    multipart.append('params', JSON.stringify(params.params))
    return Vue.http.post(getters.endpoint.createWorkspace, multipart).then((r) => {
      if (r.body.id) {
        dispatch('modelingCheckInitWorkspace', r.body.id)
      }
    })
  },
  modelingCheckInitWorkspace({ commit, getters, dispatch }, id) {
    return Vue.http.get(getters.endpoint.createWorkspaceById(id)).then((r) => {
      if (r.body.status !== 'working' && r.body.status !== 'new') {
        dispatch('getActiveWorkspaces')
        commit('setModelingNewWorkspaceCreated', {
          name: r.body.params && r.body.params.ws_name ? r.body.params.ws_name : '',
          workspace: r.body.result.workspace_id,
          version: r.body.result.data_version
        })
      } else {
        setTimeout(() => {
          dispatch('modelingCheckInitWorkspace', id)
        }, 5000)
      }
    })
  },

  updateButtonParameters({ commit, getters }, params) {
    return Vue.http.post(getters.endpoint.updateButtonParameters, params, {
      params: {
        workspace: getters.workspace,
        version: getters.version
      }
    })
  },

  /**
   * Запуск одного сервиса (одной кнопки в моделировании)
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  startService({ commit, getters }, params) {
    const requestParams = {
      params: {
        workspace_id: getters.workspace,
        data_version: getters.version,
        button: params.button
      }
    }
    if (params.isSync) {
      requestParams.status = 'out_of_turn'
    }
    return Vue.http.post(getters.endpoint.calcButton, requestParams)
  },

  /**
   * Запуск нескольких сервисов (кнопок в моделировании)
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  startServiceArray({ commit, getters }, { buttons }) {
    const requestParams = {
      params: {
        workspace_id: getters.workspace,
        data_version: getters.version,
        buttons
      }
    }
    return Vue.http.post(getters.endpoint.calcButtonArray, requestParams)
  },

  copyVersion({ commit, getters }) {
    return Vue.http
      .post(getters.endpoint.copyVersion, {
        params: {
          workspace_id: getters.workspace,
          clone_version: getters.version
        }
      })
      .then((v) => {
        commit('setIsVersionCopying', true)
      })
  },

  copyWorkspace({ commit, getters }, { workspace, version }) {
    return Vue.http
      .post(getters.endpoint.copyWorkspace, {
        params: {
          workspace_id: workspace,
          data_version: version
        }
      })
      .then((result) => {
        commit('setIsWorkspaceCopying', result.body.id)
      })
  },

  /**
   * Получить чписок версий рабочего пространства
   * @param {*} context
   * @param {*} param1
   * @returns
   */
  loadWorkspaceDataversion({ getters }, { workspace, limit = 1, is_active = 1 }) {
    return Vue.http.get(getters.endpoint.workspaceVersion, {
      params: {
        limit,
        is_active,
        workspace
      }
    })
  },

  getCopyWorkspaceResult({ commit, getters }, id) {
    return Vue.http
      .get(getters.endpoint.copyWorkspaceById(id), {
        params: {
          workspace_id: getters.workspace,
          data_version: getters.version
        }
      })
      .then((r) => {
        return r.body
      })
  },

  getModelingLogs({ commit, getters }, id) {
    return Vue.http
      .get(getters.endpoint.calcButton, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          task: id
        }
      })
      .then((v) => {
        commit('setModelingLogs', {
          id,
          log: v.body.results[0] ? v.body.results[0].log : '',
          error: v.body.results[0] ? v.body.results[0].error : ''
        })
      })
  },

  resetModelingFile({ getters }, params) {
    return Vue.http.post(getters.endpoint.uploadFile, params, {
      params: {
        workspace: getters.workspace,
        version: getters.version
      }
    })
  },
  startModelingLimitsRegularUpd({ getters, dispatch }) {
    if (limitsTimeInterval) {
      return
    }

    const clear = () => {
      clearTimeout(limitsTimeInterval)
      limitsTimeInterval = null
    }
    const startNext = () => {
      clear()
      dispatch('startModelingLimitsRegularUpd')
    }

    limitsTimeInterval = setTimeout(() => {
      if (getters.modelingNeedSystemLimits) {
        dispatch('getModelingLimits')
          .then((v) => {
            startNext()
          })
          .catch((e) => {
            startNext()
          })
      } else {
        clear()
      }
    }, 20000)
  },
  getModelingLimits({ dispatch }) {
    return Promise.all([dispatch('getModelingLimitMemory'), dispatch('getModelingLimitDisk'), dispatch('getModelingLimitCpu')])
  },
  getModelingLimitMemory({ getters, commit }) {
    return Vue.http.get(getters.endpoint.limitMemory).then((r) => {
      commit('setModelingSystemLimits', {
        id: 'memory',
        value: {
          total: (r.body.total / 1024 / 1024 / 1024).toFixed(1),
          used: (r.body.used / 1024 / 1024 / 1024).toFixed(1),
          remain: ((r.body.total - r.body.used) / 1024 / 1024 / 1024).toFixed(1),
          percent: (100 - r.body.percent_usage).toFixed(1)
        }
      })
    })
  },
  getModelingLimitDisk({ getters, commit }) {
    return Vue.http.get(getters.endpoint.limitDisk).then((r) => {
      commit('setModelingSystemLimits', {
        id: 'disk',
        value: {
          total: (r.body.total / 1024 / 1024 / 1024).toFixed(1),
          used: (r.body.used / 1024 / 1024 / 1024).toFixed(1),
          remain: ((r.body.total - r.body.used) / 1024 / 1024 / 1024).toFixed(1),
          percent: (100 - r.body.percent_usage).toFixed(1)
        }
      })
    })
  },
  getModelingLimitCpu({ getters, commit }) {
    return Vue.http.get(getters.endpoint.limitCpu).then((r) => {
      commit('setModelingSystemLimits', {
        id: 'cpu',
        value: {
          total: r.body.total,
          used: r.body.used,
          remain: r.body.total - r.body.used,
          percent: (((r.body.total - r.body.used) / r.body.total) * 100).toFixed(1),
          queued_tasks: r.body.queued_tasks || '-'
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modeling/actions.js